import InviteThroughExcel from "./Container"

export default InviteThroughExcel
